import { render, staticRenderFns } from "./BanTeam.vue?vue&type=template&id=310c016e&scoped=true"
import script from "./BanTeam.vue?vue&type=script&lang=js"
export * from "./BanTeam.vue?vue&type=script&lang=js"
import style0 from "./BanTeam.vue?vue&type=style&index=0&id=310c016e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310c016e",
  null
  
)

export default component.exports